import ContractorAdditionalDetails from "../../../newComponents/AdditionalDetails/ContractorAdditionalDetails";
import { EntityType } from "@propertelligent/client-api";
import TransactionView from "../../../newComponents/transactions/view";
import ServiceRequest from "../../../pages/service-request";
import { TenantPaymentsTabContent } from "../../../tenantComponent/components/ManageAutoPay";
import SimpleSpinner from "../../../components/loader";
import ContractorPaymentMethodTab from "../paymentMethods/ContractorPaymentMethodTab";
import "../../../tenantComponent/components/tabs/tenantDashboardTabs.css";

export const getContractorDashboardTabs = (
  activeTab: string,
  setActiveTab: (id: string) => void,
  contractorId: number,
  filteredRows: any[],
  loading: boolean,
  fetchData: (page?: number) => void,
  sentryRef: (node?: Element | null) => void,
  selectedFilter: string,
  menuItems: any[],
) => [
  // ---------------- Payments ----------------
  {
    id: "payments",
    label: "Payments",
    content:
      activeTab === "payments" ? (
        <div className="tenant-tab-content-loader-wrapper">
          {loading ? (
            <div className="tab-loader-centered">
              <SimpleSpinner myClassName="Icon50" />
            </div>
          ) : (
            <TenantPaymentsTabContent
              filteredRows={filteredRows}
              loading={loading}
              fetchData={fetchData}
              sentryRef={sentryRef}
              selectedFilter={selectedFilter}
              menuItems={menuItems}
              tenantId={contractorId}
              isContractor={true}
            />
          )}
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Service Requests ----------------
  {
    id: "services_requests",
    label: "Service Requests",
    content:
      activeTab === "services_requests" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-list-wrapper">
          <ServiceRequest
            isEntity={true}
            entityTypeId={EntityType.Contractor}
            entityId={contractorId}
            userRole="Contractor"
            parentClassName="tenant-service-request-parent"
            className="tenant-service-request"
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Transactions ----------------
  {
    id: "transactions",
    label: "Transactions",
    content:
      activeTab === "transactions" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-transaction-list">
          <TransactionView
            isEntity={true}
            entityId={contractorId}
            entityTypeId={EntityType.Contractor}
            tenatPadding="tenant-transactionHeader"
            isContractor={true}
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Payment Method ----------------
  {
    id: "payment_method",
    label: "Payment Method",
    content:
      activeTab === "payment_method" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-list-wrapper">
          <ContractorPaymentMethodTab
            contractorId={contractorId}
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },

  // ---------------- Additional Details ----------------
  {
    id: "additional_details",
    label: "Additional Details",
    content:
      activeTab === "additional_details" ? (
        <div className="tenant-tab-content-loader-wrapper tenant-list-wrapper">
          <ContractorAdditionalDetails
            entityId={contractorId}
            entityTypeId={EntityType.Contractor}
          />
        </div>
      ) : null,
    onClick: setActiveTab,
  },
];
